export default "__VITE_ASSET__BvJ5Nxfe__"